import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-col">
          <img src="/logo.svg" alt="Zuchlag" className="footer-logo" />
          <p className="footer-tagline">Industrieauktionen aus ganz Europa an einem Ort.</p>
        </div>

        <nav className="footer-col" aria-label="Footer">
          <Link to="/">Start</Link>
          <Link to="/suche">Auktionen durchsuchen</Link>
        </nav>

        <div className="footer-col footer-note">
          <p>Zuchlag ist ein Such- und Vergleichsportal. Bietungen erfolgen ausschließlich auf der jeweiligen Original-Plattform des Auktionshauses.</p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Zuchlag</span>
      </div>
    </footer>
  )
}
